module.exports = __webpack_public_path__ + "img/ys-bg-1.ae796eef.png";